export default "__VITE_ASSET__CIW3Qdh7__"